import { render, staticRenderFns } from "./commonRateList.vue?vue&type=template&id=df985798&scoped=true&"
import script from "./commonRateList.vue?vue&type=script&lang=js&"
export * from "./commonRateList.vue?vue&type=script&lang=js&"
import style0 from "./commonRateList.vue?vue&type=style&index=0&id=df985798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df985798",
  null
  
)

export default component.exports